import { GridColDef } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { format } from "date-fns";
import { Segment } from "@/apis/bacchus/types";
import { ActionsCell } from "./ActionsCell";

function formatDate(dateString: string | undefined | null): string {
  if (!dateString) return "—";
  return format(new Date(dateString), "MMM d, yyyy");
}

function formatDateFull(dateString: string | undefined | null): string {
  if (!dateString) return "";
  return format(new Date(dateString), "MMM d, yyyy 'at' h:mm a");
}

export function getColumns(
  onDeleteClick: (segment: Segment) => void,
  onEditClick: (segment: Segment) => void
): GridColDef<Segment>[] {
  return [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.row.name || ""} placement="bottom">
          <Typography
            data-testid={`segment-row-link-${params.row.id}`}
            variant="body2"
            noWrap
          >
            {params.row.name || "—"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "created_by",
      headerName: "Created by",
      width: 130,
      sortable: false,
      renderCell: (params) =>
        // permissions.write is only ever true for the segment's creator
        params.row.permissions?.write ? (
          <Chip
            data-testid={`segment-row-created-by-chip-${params.row.id}`}
            size="small"
            variant="outlined"
            color="primary"
            label="Me"
          />
        ) : (
          <Typography
            variant="body2"
            data-testid={`segment-row-created-by-${params.row.id}`}
          >
            Teammate
          </Typography>
        ),
    },
    {
      field: "inserted_at",
      headerName: "Created",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={formatDateFull(params.row.inserted_at)} placement="top">
          <Typography variant="body2">
            {formatDate(params.row.inserted_at)}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "updated_at",
      headerName: "Last Modified",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={formatDateFull(params.row.updated_at)} placement="top">
          <Typography variant="body2">
            {formatDate(params.row.updated_at)}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <ActionsCell
          segment={params.row}
          onDeleteClick={onDeleteClick}
          onEditClick={onEditClick}
        />
      ),
    },
  ];
}
